import { FC, memo } from 'react';

import { IconBaseProps } from 'icons/IconBase';

export const IconLanguageClose: FC<IconBaseProps> = memo(
  ({ size = 36, ...rest }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1259_26977)">
        <path d="M1 1L35.0003 35.0003" stroke="black" strokeWidth="2" />
        <path d="M1 35.0003L35.0003 1" stroke="black" strokeWidth="2" />
      </g>
      <defs>
        <clipPath id="clip0_1259_26977">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
);
